/* global document:true */
import React from 'react';
import ReactDOM from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Spin } from 'antd';
import * as Sentry from '@sentry/react';
// import AdminLayout from './components/AdminLayout';
// import EmptyLayout from './components/EmptyLayout';
// import Dashboard from './pages/Dashboard';
// import About from './pages/About';
// import Contact from './pages/Contact';
// import Index from './pages/NotFound';
import Routes from './core/utils/routes';
import history from './core/utils/history';


import './styles/style.css';

/**
 * ## Actions
 *  The necessary actions for dispatching our bootstrap values
 */
import { setVersion } from './core/global/globalActions';

/**
 *  The version of the app but not displayed yet
 */
import pack from '../package.json';

/**
 * ### configureStore
 */
import configureStore from './core/store';

const globalStore = configureStore({});

const { store, persistor } = globalStore;

const VERSION = pack.version;

const SENTRY_ENVIRONMENT = process.env.REACT_APP_ENV;

/**
 * ## Sentry error reporting
 *  Errors only — no performance tracing or session replay. Only enabled in
 *  deployed environments (staging + live); local dev is excluded so it does
 *  not report. The DSN is supplied via REACT_APP_SENTRY_DSN (see .env files);
 *  an empty DSN also disables sending.
 */
Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    enabled: ['stag', 'live'].includes(SENTRY_ENVIRONMENT),
    release: process.env.REACT_APP_SENTRY_RELEASE || VERSION,
});

store.dispatch(setVersion(VERSION));

ReactDOM.render(
    <Sentry.ErrorBoundary fallback={<p>An unexpected error has occurred.</p>}>
        <Provider store={store}>
            <PersistGate loading={<Spin />} persistor={persistor}>
                <Router history={history} basename="/">
                    <Routes persistor={persistor} />
                </Router>
            </PersistGate>
        </Provider>
    </Sentry.ErrorBoundary>,
    document.getElementById('root'),
);
